// Hooks
import { useRef, useEffect, useState } from 'react';
/**
 * @description Hook for handling dropdown button and handling clicks outside
 *
 * @returns {Object}
 */
export var useDropdownVisibility = function () {
    var _a = useState(false), isDropdownVisible = _a[0], setDropdownVisibility = _a[1];
    var buttonRef = useRef();
    var dropdownListRef = useRef();
    useEffect(function () {
        var closeDropdownWhenClickedOutside = function (event) {
            var withBoundaries = event.composedPath();
            if (!withBoundaries.includes(buttonRef.current) && !withBoundaries.includes(dropdownListRef.current)) {
                setDropdownVisibility(false);
            }
        };
        var closeDropdownOnScroll = function () { return setDropdownVisibility(false); };
        document.addEventListener('click', closeDropdownWhenClickedOutside);
        document.addEventListener('scroll', closeDropdownOnScroll);
        return function () {
            document.removeEventListener('click', closeDropdownWhenClickedOutside);
            document.removeEventListener('scroll', closeDropdownOnScroll);
        };
    }, []);
    return { buttonRef: buttonRef, dropdownListRef: dropdownListRef, setDropdownVisibility: setDropdownVisibility, isDropdownVisible: isDropdownVisible };
};
//# sourceMappingURL=useDropdownVisibility.js.map